import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import * as LucideIcons from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import { industries } from '../../data/industries';

const IndustriesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      
      <main className="pt-20">
        <section className="bg-slate-900 py-20 lg:py-28">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <h1 className="text-4xl lg:text-5xl font-bold text-white max-w-4xl leading-tight">
              Intelligence across every industry
            </h1>
            <p className="mt-6 text-lg text-slate-400 max-w-2xl">
              TradeEngine.AI adapts to your industry's unique challenges, providing tailored intelligence 
              that transforms operations and drives measurable results.
            </p>
          </div>
        </section>

        <section className="py-20 lg:py-28 bg-slate-50 dark:bg-slate-950">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {industries.map((industry) => {
                const Icon = LucideIcons[industry.icon];

                const card = (
                  <div className="group bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-6 hover:border-slate-300 dark:hover:border-slate-700 transition-all duration-300">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-lg bg-slate-100 dark:bg-slate-800 flex items-center justify-center flex-shrink-0">
                        {Icon && <Icon className="w-6 h-6 text-slate-600 dark:text-slate-400 group-hover:text-orange-500 transition-colors" />}
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2 group-hover:text-orange-500 transition-colors">
                          {industry.title}
                        </h3>
                        <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed mb-4">
                          {industry.shortDescription}
                        </p>
                        {industry.slug === "logistics" && (
                          <div className="flex items-center text-sm text-orange-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                            Learn more
                            <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );

                return industry.slug === "logistics" ? (
                 <Link
  key={industry.id}
  to={`/industries/${industry.slug}`}
  onClick={() => window.scrollTo(0, 0)}
>
  {card}
</Link>

                ) : (
                  <div key={industry.id}>{card}</div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="py-20 bg-white dark:bg-slate-900 border-t border-slate-100 dark:border-slate-800">
          <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-2xl lg:text-3xl font-bold text-slate-900 dark:text-white mb-4">
              Don't see your industry?
            </h2>
            <p className="text-slate-600 dark:text-slate-400 mb-8">
              TradeEngine.AI's flexible architecture adapts to any physical-economy business. 
              Contact us to discuss your specific requirements.
            </p>
            <Link
              to="/#contact"
              className="inline-flex items-center px-6 py-3 bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-medium rounded-lg hover:bg-slate-800 dark:hover:bg-slate-100 transition-colors"
            >
              Contact Us
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default IndustriesPage;
